import React from 'react'
import clsx from 'clsx'
import useDeprecatedComponent from '../../lib/hooks/useDeprecatedComponent'
import { createUseStyles } from '../../lib/styling'
import { FlexLayout, FlexLayoutProps } from '../internal/FlexLayout'
import { AlignItems, JustifyContent, Spacing } from '../helperTypes'

export type InlineProps = {
  /** Aligns children horizontally */
  align?: JustifyContent
  /** Aligns children vertically */
  alignY?: AlignItems
  /** Specifies the gap beween children */
  spacing?: Spacing
  /** If true, children will wrap on multiple lines */
  wrap?: boolean
} & FlexLayoutProps

const useStyles = createUseStyles(
  (theme: any) => ({
    root: {
      display: 'flex',
      flexWrap: 'nowrap',
      alignItems: ({ alignY }: InlineProps) => (alignY !== 'start' && alignY !== 'end' ? alignY : `flex-${alignY}`),
      justifyContent: ({ align }: InlineProps) => (align !== 'start' && align !== 'end' ? align : `flex-${align}`),
      margin: ({ spacing }: InlineProps) => (spacing ? `calc(-${theme.size.spacing.inset[spacing]} / 2)` : 0),
    },
    wrap: {
      flexWrap: 'wrap',
    },
    child: {
      margin: ({ spacing }: InlineProps) => (spacing ? `calc(${theme.size.spacing.inset[spacing]} / 2)` : 0),
    },
  }),
  'inline',
)

const Inline = ({
  className,
  childrenClassName,
  align = 'start',
  alignY = 'center',
  spacing,
  wrap,
  ...rest
}: InlineProps) => {
  const classes = useStyles({ spacing, align, alignY })
  return (
    <FlexLayout
      className={clsx(className, classes.root, wrap && classes.wrap)}
      childrenClassName={clsx(classes.child, childrenClassName)}
      {...rest}
    />
  )
}

export default Inline

// Retro compatibility with Wrap component
export const Wrap = (props: InlineProps) => {
  useDeprecatedComponent('Wrap', 'Please use Inline.')
  return <Inline wrap {...props} />
}
